<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-label data-cy="add-product-label">
      {{ 'i18n.orderPage.addToOrderModal.addProductToOrder' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="create-list_content ion-content-modal-mobile">
  <ion-item-divider></ion-item-divider>
  <ion-item data-cy="add-to-order-button" detail (click)="goToStartNewOrder()">
    <ion-label class="add-to-order-option" data-cy="add-to-order-label">
      {{ 'i18n.orderPage.addToOrderModal.createNewOrder' | translate }}
    </ion-label>
  </ion-item>

  <ion-item
    data-cy="add-to-order-button"
    detail
    (click)="goToAddToExistingOrder()"
  >
    <ion-label class="add-to-order-option" data-cy="add-to-order-label">
      {{ 'i18n.orderPage.addToOrderModal.addToExistingOrder' | translate }} ({{
        vm?.length
      }})
      <br />
      <span class="item-note" [ngClass]="{ selected: currentTab === 2 }">
        <ng-container *ngIf="vm?.length > 0; else noOrdersInAddProductsText">
          {{ 'i18n.orderPage.addToOrderModal.timeToAddProducts' | translate }}
        </ng-container>
        <ng-template #noOrdersInAddProductsText>
          {{
            'i18n.orderPage.addToOrderModal.noOrdersInAddProducts' | translate
          }}
        </ng-template>
      </span>
    </ion-label>
  </ion-item>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        class="usf-outline-green-mobile-modal-button"
        data-cy="add-to-order-close-button"
        (click)="closeModal()"
      >
        {{ 'i18n.common.close' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
